require('./fos_user.module');
require('./controllers/login.controller');
require('./controllers/registration.controller');